import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { X } from "lucide-react";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { toggle } = useWishlist();

  const load = async () => {
    try { setItems((await api.get("/wishlist")).data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (pid) => {
    await toggle(pid);
    setItems((x) => x.filter((it) => it.product_id !== pid));
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Your Account</p>
      <h1 className="font-serif text-6xl tracking-tighter">Wishlist.</h1>

      {loading ? null : items.length === 0 ? (
        <p className="mt-10 font-serif text-2xl text-muted-foreground">
          Nothing saved yet. <Link to="/shop" className="underline">Browse the shop.</Link>
        </p>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {items.map(({ product: p, product_id }) => (
            <div key={product_id} className="border border-foreground group relative">
              <button onClick={() => remove(product_id)} aria-label="remove"
                className="absolute top-2 right-2 z-10 bg-background border border-foreground p-1.5 hover:bg-foreground hover:text-background">
                <X size={14} strokeWidth={1.5} />
              </button>
              <Link to={`/product/${p.id}`}>
                <div className="aspect-[4/5] bg-secondary overflow-hidden">
                  {p.images?.[0] && <img src={p.images[0]} alt={p.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform" />}
                </div>
                <div className="p-3">
                  <p className="font-mono text-[9px] uppercase tracking-widest text-muted-foreground">{p.vendor_slug}</p>
                  <p className="font-serif text-lg leading-tight mt-1">{p.title}</p>
                  <p className="font-mono text-sm mt-1">₹ {p.price?.toLocaleString("en-IN")}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
